import day from 'dayjs'

export const defaultDateTime = {
  fromDate: day().format('YYYY-MM-DD'),
  fromTime: '00:00', 
  toDate: day().format('YYYY-MM-DD'),
  toTime: '23:59'
}